module.exports = __webpack_public_path__ + "i18n/pt-BR.04ed576f25f0fb55c2e830d37e6056e2.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/pt-BR.json
// module id = 1064
// module chunks = 60